import { ReactNode } from 'react';

interface InfoBlockProps {
  caption?: string;
  text?: string;
  className?: string;
  children?: ReactNode;
}

const InfoBlock = ({ caption = '', text = '', className = '', children = null }: InfoBlockProps) => {
  return (
    <div className={`py-3 ${className}`}>
      <p className="text-uppercase fs-7 text-gray-900 mb-1">{caption}</p>
      {children || <p className="fs-3">{text}</p>}
    </div>
  );
};

export default InfoBlock;
